import { api } from './api'

// The current user's markups for one document (standard string).
export function listMarkups(standard) {
  const query = `?standard=${encodeURIComponent(standard)}`
  return api.get(`/markups${query}`).then((data) => data.markups)
}

// Create a markup. Payload: { standard, page, type, geometry, style?, text? }.
export function createMarkup(payload) {
  return api.post('/markups', payload).then((data) => data.markup)
}

// Partial update: { geometry?, style?, text?, page? }.
export function updateMarkup(id, changes) {
  return api.patch(`/markups/${id}`, changes).then((data) => data.markup)
}

// Remove a markup. Resolves to the deleted markup.
export function deleteMarkup(id) {
  return api.del(`/markups/${id}`).then((data) => data.markup)
}
